import { render, staticRenderFns } from "./Bbslist.vue?vue&type=template&id=57351fd8&"
import script from "./Bbslist.vue?vue&type=script&lang=js&"
export * from "./Bbslist.vue?vue&type=script&lang=js&"
import style0 from "./Bbslist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports